var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488.88 251.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666766;\n        stroke: #808285;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.06,2.88L246.96,131.97c-2.5,2.5-6.57,2.5-9.07,0L108.8,2.88c-1.2-1.2-2.83-1.88-4.54-1.88H7.43C1.71,1-1.15,7.91,2.89,11.95L239.91,248.96c2.5,2.5,6.57,2.5,9.07,0L485.99,11.95c4.04-4.04,1.18-10.95-4.54-10.95h-100.87c-1.7,0-3.33,.68-4.54,1.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown_arrow.f66e8c5bb4c8d5f1c13cefe655014f81.svg";
export { ForwardRef as ReactComponent };